import { useEffect, useRef, useState } from "react";

import cleanser from './assets/cleansing2.jpeg';
import serum from './assets/serum2.jpeg';
import spf from './assets/protection.jpeg';
import mist from './assets/hydration.jpeg';
import mask from './assets/treatment.jpeg';
import aboutImg from './assets/about.jpeg'; // 👈 save image 1 as src/assets/about.jpeg

const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400;1,500&family=Jost:wght@300;400;500&display=swap');
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    :root {
      --cream: #F2EDE6; --sand: #E4D9CC; --dark: #2C1F14;
      --brown: #4A3728; --mid: #7A6355; --light: #B8A898; --white: #FFFFFF;
    }
    html { scroll-behavior: smooth; }
    body { font-family: 'Jost', sans-serif; background: var(--cream); color: var(--brown); overflow-x: hidden; }

    /* NAV */
    .onya-nav { position: fixed; top: 0; left: 0; right: 0; z-index: 300; display: flex; align-items: center; justify-content: space-between; padding: 0 52px; height: 70px; background: rgba(242,237,230,0.97); backdrop-filter: blur(14px); }
    .onya-nav-logo { font-family: 'Cormorant Garamond', serif; font-size: 1.45rem; font-weight: 400; letter-spacing: 0.32em; color: var(--dark); text-decoration: none; flex-shrink: 0; }
    .onya-nav-center { display: flex; gap: 48px; list-style: none; position: absolute; left: 50%; transform: translateX(-50%); }
    .onya-nav-center a { font-size: 0.7rem; letter-spacing: 0.16em; text-transform: uppercase; color: var(--brown); text-decoration: none; transition: color 0.2s; white-space: nowrap; }
    .onya-nav-center a:hover { color: var(--dark); }
    .onya-nav-right { display: flex; align-items: center; gap: 16px; flex-shrink: 0; }
    .onya-nav-btn { background: var(--dark); color: var(--cream); border: none; padding: 12px 28px; font-family: 'Jost', sans-serif; font-size: 0.7rem; letter-spacing: 0.16em; text-transform: uppercase; cursor: pointer; transition: background 0.25s; white-space: nowrap; line-height: 1; }
    .onya-nav-btn:hover { background: var(--brown); }
    .onya-hamburger { display: none; flex-direction: column; gap: 5px; background: none; border: none; cursor: pointer; padding: 4px; }
    .onya-hamburger span { display: block; width: 24px; height: 2px; background: var(--dark); transition: all 0.3s ease; }
    .onya-hamburger.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
    .onya-hamburger.open span:nth-child(2) { opacity: 0; }
    .onya-hamburger.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }
    .onya-mobile-menu { position: fixed; top: 70px; left: 0; right: 0; z-index: 250; background: rgba(242,237,230,0.98); backdrop-filter: blur(14px); display: flex; flex-direction: column; align-items: center; padding: 0; max-height: 0; overflow: hidden; transition: max-height 0.4s ease, padding 0.3s ease; border-bottom: 1px solid var(--sand); }
    .onya-mobile-menu.open { max-height: 400px; padding: 32px 0 28px; }
    .onya-mobile-menu a { font-size: 0.78rem; letter-spacing: 0.2em; text-transform: uppercase; color: var(--brown); text-decoration: none; padding: 14px 0; width: 100%; text-align: center; border-bottom: 1px solid rgba(228,217,204,0.5); transition: color 0.2s; }
    .onya-mobile-menu a:hover { color: var(--dark); }
    .onya-mobile-menu button { margin-top: 20px; background: var(--dark); color: var(--cream); border: none; padding: 14px 48px; font-family: 'Jost', sans-serif; font-size: 0.72rem; letter-spacing: 0.18em; text-transform: uppercase; cursor: pointer; }

    /* HERO */
    .onya-hero { position: relative; min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; padding: 120px 40px 110px; overflow: hidden; background: var(--cream); }
    .onya-hero-backdrop { position: absolute; inset: 0; z-index: 0; pointer-events: none; overflow: hidden; }
    .onya-hero-backdrop svg { position: absolute; top: 50%; left: 50%; transform: translate(-50%,-50%); width: 95%; max-width: 1100px; }
    .onya-hero-content { position: relative; z-index: 2; max-width: 680px; }
    .onya-hero-tag { display: inline-block; border: 1px solid rgba(74,55,40,0.45); padding: 8px 30px; font-size: 0.65rem; letter-spacing: 0.32em; text-transform: uppercase; color: var(--brown); margin-bottom: 34px; }
    .onya-hero-title { font-family: 'Cormorant Garamond', serif; font-size: clamp(5rem,11vw,9.5rem); font-weight: 300; letter-spacing: 0.16em; color: var(--dark); line-height: 1; margin-bottom: 22px; }
    .onya-hero-sub { font-family: 'Cormorant Garamond', serif; font-size: clamp(1.5rem,3vw,2.1rem); font-weight: 300; font-style: italic; color: var(--brown); margin-bottom: 20px; }
    .onya-hero-desc { font-size: 0.88rem; line-height: 1.85; color: var(--mid); max-width: 520px; margin: 0 auto 38px; }
    .onya-chevron { margin: 0 auto 30px; color: var(--mid); font-size: 1.4rem; animation: onyaBounce 2.2s ease-in-out infinite; }
    @keyframes onyaBounce { 0%,100%{transform:translateY(0)} 50%{transform:translateY(8px)} }
    .onya-hero-cta { background: var(--dark); color: var(--cream); border: none; padding: 18px 54px; font-family: 'Jost', sans-serif; font-size: 0.7rem; letter-spacing: 0.22em; text-transform: uppercase; cursor: pointer; transition: background 0.25s; display: inline-flex; align-items: center; gap: 10px; }
    .onya-hero-cta:hover { background: var(--brown); }

    /* COLLECTION */
    .onya-coll-header { text-align: center; padding: 90px 40px 60px; }
    .onya-coll-tag { font-size: 0.65rem; letter-spacing: 0.28em; text-transform: uppercase; color: var(--mid); margin-bottom: 18px; display: flex; align-items: center; justify-content: center; gap: 14px; }
    .onya-coll-star { color: var(--brown); }
    .onya-coll-title { font-family: 'Cormorant Garamond', serif; font-size: clamp(2.4rem,5vw,4.4rem); font-weight: 300; color: var(--dark); margin-bottom: 16px; line-height: 1.1; }
    .onya-coll-desc { font-size: 0.88rem; color: var(--mid); max-width: 480px; margin: 0 auto; line-height: 1.8; }

    /* PRODUCT GRIDS */
    .onya-collection-section { background: #EEEBE6; padding: 0 28px 48px; }
    .onya-grid3 { display: grid; grid-template-columns: repeat(3,1fr); gap: 20px; margin-bottom: 20px; }
    .onya-grid2 { display: grid; grid-template-columns: repeat(2,1fr); gap: 20px; }
    .onya-pcard { display: flex; flex-direction: column; background: var(--white); cursor: pointer; transition: box-shadow 0.3s, transform 0.3s; border-radius: 2px; overflow: hidden; }
    .onya-pcard:hover { box-shadow: 0 12px 40px rgba(44,31,20,0.12); transform: translateY(-2px); }
    .onya-pcard-illus { position: relative; height: 280px; overflow: hidden; }
    .onya-pcard-photo { width: 100%; height: 100%; object-fit: cover; object-position: center 40%; display: block; transition: transform 0.5s ease; }
    .onya-pcard:hover .onya-pcard-photo { transform: scale(1.04); }
    .onya-pcard-tag { position: absolute; top: 16px; left: 16px; z-index: 3; background: rgba(255,255,255,0.92); padding: 6px 14px; font-size: 0.7rem; letter-spacing: 0.06em; color: var(--dark); }
    .onya-pcard-body { padding: 28px 24px 34px; flex: 1; }
    .onya-pcard-name { font-family: 'Cormorant Garamond', serif; font-size: 1.3rem; font-weight: 500; color: var(--dark); margin-bottom: 12px; line-height: 1.25; }
    .onya-pcard-desc { font-size: 0.8rem; color: var(--mid); line-height: 1.78; margin-bottom: 18px; }
    .onya-pcard-feats { list-style: none; display: flex; flex-direction: column; gap: 8px; margin-bottom: 22px; padding: 0; }
    .onya-pcard-feats li { font-size: 0.78rem; color: var(--brown); display: flex; align-items: center; gap: 10px; }
    .onya-pcard-feats li::before { content:''; width:6px; height:6px; background:var(--dark); flex-shrink:0; display:inline-block; }
    .onya-pcard-hr { border: none; border-top: 1px solid #EAE0D5; margin-bottom: 14px; }
    .onya-pcard-size { font-size: 0.75rem; color: var(--light); }

    /* ── ABOUT — light layout matching reference ── */
    .onya-about {
      background: #EEEBE6;
      padding: 80px 60px;
    }
    .onya-about-inner {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 64px;
      align-items: center;
      max-width: 1200px;
      margin: 0 auto;
    }

    /* Left image */
    .onya-about-img-wrap {
      width: 100%;
      aspect-ratio: 1 / 1;
      overflow: hidden;
      border-radius: 2px;
    }
    .onya-about-img-wrap img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center center;
      display: block;
    }

    /* Right text */
    .onya-about-right {}
    .onya-about-eyebrow {
      font-size: 0.65rem;
      letter-spacing: 0.26em;
      text-transform: uppercase;
      color: var(--mid);
      margin-bottom: 18px;
    }
    .onya-about-title {
      font-family: 'Cormorant Garamond', serif;
      font-size: clamp(2.2rem, 4vw, 3.4rem);
      font-weight: 400;
      color: var(--dark);
      line-height: 1.1;
      margin-bottom: 28px;
    }
    .onya-about-text {
      font-size: 0.88rem;
      color: var(--mid);
      line-height: 1.9;
      margin-bottom: 16px;
    }
    .onya-about-divider { width: 100%; height: 1px; background: var(--sand); margin: 36px 0; }

    /* Pillars */
    .onya-pillars { display: flex; flex-direction: column; gap: 28px; }
    .onya-pillar { display: flex; gap: 20px; align-items: flex-start; }
    .onya-pillar-ico {
      width: 52px; height: 52px; flex-shrink: 0;
      border: 1px solid var(--sand);
      background: var(--white);
      display: flex; align-items: center; justify-content: center;
      font-size: 1.1rem;
      border-radius: 2px;
    }
    .onya-pillar-text {}
    .onya-pillar-name {
      font-family: 'Cormorant Garamond', serif;
      font-size: 1.1rem; font-weight: 500;
      color: var(--dark); margin-bottom: 5px;
    }
    .onya-pillar-desc { font-size: 0.8rem; color: var(--mid); line-height: 1.7; }

    /* NOTIFY */
    .onya-notify { background: var(--brown); padding: 100px 40px; text-align: center; position: relative; overflow: hidden; }
    .onya-notify-grid { position:absolute; inset:0; pointer-events:none; background-image:linear-gradient(rgba(255,255,255,0.05) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,0.05) 1px,transparent 1px); background-size:38px 38px; }
    .onya-notify-inner { position:relative; z-index:2; }
    .onya-notify-icon { width:58px; height:58px; background:rgba(255,255,255,0.09); border:1px solid rgba(255,255,255,0.2); display:flex; align-items:center; justify-content:center; margin:0 auto 44px; font-size:1.2rem; color:var(--cream); }
    .onya-notify-title { font-family:'Cormorant Garamond',serif; font-size:clamp(2.4rem,5vw,3.8rem); font-weight:300; color:var(--cream); margin-bottom:20px; line-height:1.1; }
    .onya-notify-desc { font-size:0.85rem; color:rgba(242,237,230,0.65); max-width:540px; margin:0 auto 46px; line-height:1.85; }
    .onya-notify-form { display:flex; max-width:560px; margin:0 auto 14px; }
    .onya-notify-input { flex:1; padding:16px 22px; background:rgba(255,255,255,0.09); border:1px solid rgba(255,255,255,0.22); color:var(--cream); font-family:'Jost',sans-serif; font-size:0.83rem; outline:none; }
    .onya-notify-input::placeholder { color:rgba(242,237,230,0.38); }
    .onya-notify-submit { background:var(--cream); color:var(--dark); border:none; padding:16px 32px; font-family:'Jost',sans-serif; font-size:0.7rem; letter-spacing:0.18em; text-transform:uppercase; cursor:pointer; white-space:nowrap; transition:background 0.25s; }
    .onya-notify-submit:hover { background:var(--sand); }
    .onya-notify-privacy { font-size:0.72rem; color:rgba(242,237,230,0.38); margin-bottom:52px; }
    .onya-notify-perks { display:flex; justify-content:center; gap:40px; flex-wrap:wrap; }
    .onya-perk { display:flex; align-items:center; gap:10px; font-size:0.75rem; color:rgba(242,237,230,0.62); }
    .onya-perk::before { content:''; width:6px; height:6px; background:rgba(242,237,230,0.42); flex-shrink:0; display:inline-block; }

    /* FOOTER */
    .onya-footer {
      background: var(--dark);
      padding: 64px 60px 0;
    }
    .onya-footer-top {
      display: grid;
      grid-template-columns: 1.2fr 1fr 1fr;
      gap: 48px;
      padding-bottom: 52px;
    }
    /* Brand col */
    .onya-f-brand {}
    .onya-f-logo {
      font-family: 'Cormorant Garamond', serif;
      font-size: 1.5rem; font-weight: 400; letter-spacing: 0.3em;
      color: var(--cream); display: block; margin-bottom: 20px;
    }
    .onya-f-tagline {
      font-size: 0.82rem; color: rgba(242,237,230,0.52);
      line-height: 1.75; max-width: 280px;
    }
    /* Links col */
    .onya-f-col-title {
      font-size: 0.65rem; letter-spacing: 0.22em; text-transform: uppercase;
      color: rgba(242,237,230,0.45); margin-bottom: 22px;
    }
    .onya-f-links { display: flex; flex-direction: column; gap: 14px; }
    .onya-f-links a {
      font-size: 0.82rem; color: rgba(242,237,230,0.65);
      text-decoration: none; transition: color 0.2s;
    }
    .onya-f-links a:hover { color: var(--cream); }
    /* Social col */
    .onya-f-socials { display: flex; gap: 12px; margin-bottom: 22px; }
    .onya-f-social-btn {
      width: 42px; height: 42px;
      border: 1px solid rgba(255,255,255,0.18);
      background: rgba(255,255,255,0.05);
      display: flex; align-items: center; justify-content: center;
      cursor: pointer; transition: background 0.2s, border-color 0.2s;
      color: rgba(242,237,230,0.7); font-size: 0.95rem;
      text-decoration: none;
    }
    .onya-f-social-btn:hover { background: rgba(255,255,255,0.12); border-color: rgba(255,255,255,0.35); color: var(--cream); }
    .onya-f-social-note {
      font-size: 0.78rem; color: rgba(242,237,230,0.4);
      line-height: 1.7; max-width: 260px;
    }
    /* Bottom bar */
    .onya-footer-bottom {
      border-top: 1px solid rgba(255,255,255,0.1);
      padding: 22px 0;
      display: flex; justify-content: space-between; align-items: center;
      flex-wrap: wrap; gap: 12px;
    }
    .onya-f-copy { font-size: 0.72rem; color: rgba(242,237,230,0.28); }
    .onya-f-legal { display: flex; gap: 28px; }
    .onya-f-legal a {
      font-size: 0.72rem; color: rgba(242,237,230,0.38);
      text-decoration: none; transition: color 0.2s;
    }
    .onya-f-legal a:hover { color: var(--cream); }

    @media (max-width: 900px) {
      .onya-footer { padding: 48px 28px 0; }
      .onya-footer-top { grid-template-columns: 1fr; gap: 40px; }
      .onya-f-logo { font-size: 1.6rem; letter-spacing: 0.2em; }
      .onya-f-tagline { max-width: 100%; }
      .onya-f-social-note { max-width: 100%; }
      .onya-footer-bottom { flex-direction: column; align-items: flex-start; gap: 10px; }
      .onya-f-legal { flex-direction: row; gap: 28px; }
    }

    .onya-fade { opacity:0; transform:translateY(22px); transition:opacity 0.65s ease,transform 0.65s ease; }
    .onya-fade.in { opacity:1; transform:translateY(0); }

    /* RESPONSIVE */
    @media (max-width: 900px) {
      .onya-nav { padding: 0 24px; }
      .onya-nav-center, .onya-nav-btn { display: none; }
      .onya-hamburger { display: flex; }
      .onya-collection-section { padding: 0 16px 32px; }
      .onya-grid3, .onya-grid2 { grid-template-columns: 1fr; gap: 16px; }
      .onya-pcard-illus { height: 260px; }
      .onya-about { padding: 60px 28px; }
      .onya-about-inner { grid-template-columns: 1fr; gap: 36px; }
      .onya-about-img-wrap { aspect-ratio: 4 / 3; }
      .onya-notify { padding: 72px 28px; }
      .onya-notify-form { flex-direction: column; }
      .onya-notify-input, .onya-notify-submit { width: 100%; padding: 16px; }
      .onya-notify-perks { flex-direction: column; align-items: center; gap: 14px; }
      .onya-footer { padding: 48px 24px 0; }
    }
    @media (max-width: 480px) {
      .onya-nav { padding: 0 20px; height: 64px; }
      .onya-mobile-menu { top: 64px; }
      .onya-nav-logo { font-size: 1.2rem; }
      .onya-hero { padding: 100px 24px 80px; }
      .onya-hero-cta { padding: 16px 32px; font-size: 0.65rem; width: 100%; justify-content: center; }
      .onya-coll-header { padding: 60px 24px 40px; }
      .onya-pcard-illus { height: 220px; }
      .onya-pcard-body { padding: 22px 20px 28px; }
      .onya-about { padding: 48px 20px; }
      .onya-notify { padding: 60px 20px; }
    }
  `}</style>
);

function useFadeUp() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => { if (e.isIntersecting) el.classList.add("in"); },
      { threshold: 0.08 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}

const products = [
  {
    id: 1, tag: "Cleansing", photo: cleanser,
    name: "Radiance Facial Cleanser",
    desc: "A gentle, luxurious cleanser that removes impurities while maintaining your skin's natural moisture balance. Infused with botanical extracts.",
    features: ["Deep cleansing", "Balances pH", "Natural botanicals"],
    size: "150ml",
  },
  {
    id: 2, tag: "Serum", photo: serum,
    name: "Aqua Bloom Hydrating Serum",
    desc: "An intensely hydrating serum that penetrates deep into the skin, delivering long-lasting moisture and a radiant, dewy glow.",
    features: ["Deep hydration", "Plumps skin", "Radiant glow"],
    size: "30ml",
  },
  {
    id: 3, tag: "Protection", photo: spf,
    name: "Sunlit Glow SPF 50 Tinted Moisturizer",
    desc: "A luxurious tinted moisturizer with broad-spectrum SPF 50 protection. Provides flawless coverage while nourishing your skin.",
    features: ["SPF 50 protection", "Even skin tone", "Lightweight coverage"],
    size: "50ml",
  },
  {
    id: 4, tag: "Hydration", photo: mist,
    name: "Essence Revival Face Mist",
    desc: "A refreshing face mist that instantly revitalizes and hydrates your skin throughout the day. Perfect for setting makeup or a midday refresh.",
    features: ["Instant refresh", "Sets makeup", "All-day hydration"],
    size: "100ml",
  },
  {
    id: 5, tag: "Treatment", photo: mask,
    name: "Detox Charcoal Purifying Mask",
    desc: "A powerful detoxifying mask with activated charcoal that draws out impurities, minimizes pores, and leaves skin feeling renewed.",
    features: ["Deep detox", "Minimizes pores", "Purifies skin"],
    size: "75ml",
  },
];

function ProductCard({ product }) {
  const ref = useFadeUp();
  return (
    <div className="onya-pcard onya-fade" ref={ref}>
      <div className="onya-pcard-illus">
        <span className="onya-pcard-tag">{product.tag}</span>
        <img src={product.photo} alt={product.name} className="onya-pcard-photo" />
      </div>
      <div className="onya-pcard-body">
        <h3 className="onya-pcard-name">{product.name}</h3>
        <p className="onya-pcard-desc">{product.desc}</p>
        <ul className="onya-pcard-feats">
          {product.features.map((f) => <li key={f}>{f}</li>)}
        </ul>
        <hr className="onya-pcard-hr" />
        <span className="onya-pcard-size">{product.size}</span>
      </div>
    </div>
  );
}

export default function App() {
  const heroRef   = useRef(null);
  const collRef   = useFadeUp();
  const aboutRef  = useFadeUp();
  const notifyRef = useFadeUp();
  const [menuOpen, setMenuOpen]   = useState(false);
  const [email, setEmail]         = useState("");
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => { if (heroRef.current) heroRef.current.classList.add("in"); }, 120);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!menuOpen) return;
    const close = () => setMenuOpen(false);
    document.addEventListener("click", close);
    return () => document.removeEventListener("click", close);
  }, [menuOpen]);

  const scrollTo = (id) => {
    setMenuOpen(false);
    setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 50);
  };

  const handleNotify = () => { if (email.trim()) { setSubmitted(true); setEmail(""); } };

  return (
    <>
      <GlobalStyles />

      {/* NAV */}
      <nav className="onya-nav">
        <a className="onya-nav-logo" href="/">O N Y A</a>
        <ul className="onya-nav-center">
          <li><a href="#collection" onClick={(e) => { e.preventDefault(); scrollTo("collection"); }}>Products</a></li>
          <li><a href="#about" onClick={(e) => { e.preventDefault(); scrollTo("about"); }}>About</a></li>
        </ul>
        <div className="onya-nav-right">
          <button className="onya-nav-btn" onClick={() => scrollTo("notify")}>Notify Me</button>
          <button
            className={`onya-hamburger${menuOpen ? " open" : ""}`}
            onClick={(e) => { e.stopPropagation(); setMenuOpen(!menuOpen); }}
            aria-label="Menu"
          >
            <span /><span /><span />
          </button>
        </div>
      </nav>

      {/* MOBILE MENU */}
      <div className={`onya-mobile-menu${menuOpen ? " open" : ""}`} onClick={(e) => e.stopPropagation()}>
        <a href="#collection" onClick={(e) => { e.preventDefault(); scrollTo("collection"); }}>Products</a>
        <a href="#about" onClick={(e) => { e.preventDefault(); scrollTo("about"); }}>About</a>
        <button onClick={() => scrollTo("notify")}>Notify Me</button>
      </div>

      {/* HERO */}
      <section className="onya-hero">
        <div className="onya-hero-backdrop">
          <svg viewBox="0 0 1100 640" fill="none">
            <circle cx="160" cy="320" r="220" fill="#C9A070" opacity="0.11"/>
            <circle cx="160" cy="320" r="155" fill="#E8D0B0" opacity="0.15"/>
            <circle cx="940" cy="210" r="185" fill="#C9A070" opacity="0.10"/>
            <circle cx="940" cy="210" r="116" fill="#EAD8B8" opacity="0.14"/>
            <circle cx="580" cy="540" r="140" fill="#C0A068" opacity="0.09"/>
            <ellipse cx="88" cy="500" rx="76" ry="29" transform="rotate(-32 88 500)" fill="#7A9A68" opacity="0.13"/>
            <ellipse cx="1010" cy="460" rx="60" ry="23" transform="rotate(22 1010 460)" fill="#7A9A68" opacity="0.11"/>
          </svg>
        </div>
        <div className="onya-hero-content onya-fade" ref={heroRef}>
          <div className="onya-hero-tag">Launching Soon</div>
          <h1 className="onya-hero-title">ONYA</h1>
          <p className="onya-hero-sub">Own Your Aura</p>
          <p className="onya-hero-desc">
            Experience the essence of luxury skincare. Our carefully crafted collection
            celebrates natural beauty through timeless rituals and sustainable practices.
          </p>
          <div className="onya-chevron">&#8964;</div>
          <button className="onya-hero-cta" onClick={() => scrollTo("notify")}>
            Get Notified at Launch &nbsp;→
          </button>
        </div>
      </section>

      {/* COLLECTION */}
      <section id="collection">
        <div className="onya-coll-header onya-fade" ref={collRef}>
          <p className="onya-coll-tag">
            <span className="onya-coll-star">✦</span> Our Collection <span className="onya-coll-star">✦</span>
          </p>
          <h2 className="onya-coll-title">Luxury Skincare Essentials</h2>
          <p className="onya-coll-desc">
            Five meticulously crafted products designed to transform your daily skincare ritual
          </p>
        </div>
        <div className="onya-collection-section">
          <div className="onya-grid3">
            {products.slice(0, 3).map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
          <div className="onya-grid2">
            {products.slice(3).map((p) => <ProductCard key={p.id} product={p} />)}
          </div>
        </div>
      </section>

      {/* ABOUT — light layout with photo left, text right */}
      <section id="about" className="onya-about">
        <div className="onya-about-inner onya-fade" ref={aboutRef}>

          {/* Left — photo */}
          <div className="onya-about-img-wrap">
            <img src={aboutImg} alt="ONYA skincare ingredients" />
          </div>

          {/* Right — text */}
          <div className="onya-about-right">
            <p className="onya-about-eyebrow">About Onya</p>
            <h2 className="onya-about-title">Own Your Aura</h2>
            <p className="onya-about-text">
              ONYA embodies the essence of luxury skincare, crafted for those who believe in
              the power of natural beauty and self-care rituals.
            </p>
            <p className="onya-about-text">
              Every ONYA product is a testament to our dedication to excellence. We believe
              that luxury skincare should be both indulgent and responsible, combining the
              wisdom of nature with modern formulation science.
            </p>
            <div className="onya-about-divider" />
            <div className="onya-pillars">
              {[
                { ico: "🌿", name: "Natural Ingredients",  desc: "Sourced from nature's finest botanicals, carefully selected for their purity and efficacy." },
                { ico: "♡",  name: "Sustainable Luxury",   desc: "Committed to ethical practices and sustainable packaging that honors our planet." },
                { ico: "✦",  name: "Timeless Beauty",      desc: "Celebrating your natural radiance with products that enhance, never mask." },
              ].map((p) => (
                <div className="onya-pillar" key={p.name}>
                  <div className="onya-pillar-ico">{p.ico}</div>
                  <div className="onya-pillar-text">
                    <div className="onya-pillar-name">{p.name}</div>
                    <p className="onya-pillar-desc">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* NOTIFY */}
      <section id="notify" className="onya-notify">
        <div className="onya-notify-grid" />
        <div className="onya-notify-inner onya-fade" ref={notifyRef}>
          <div className="onya-notify-icon">✉</div>
          <h2 className="onya-notify-title">Be the First to Know</h2>
          <p className="onya-notify-desc">
            Join our exclusive list and receive early access to ONYA's launch, special offers,
            and skincare rituals curated just for you.
          </p>
          {submitted ? (
            <p style={{color:"var(--cream)",fontFamily:"'Cormorant Garamond',serif",fontSize:"1.2rem",fontStyle:"italic",marginBottom:"52px"}}>
              ✦ Thank you! We'll be in touch soon.
            </p>
          ) : (
            <>
              <div className="onya-notify-form">
                <input
                  className="onya-notify-input"
                  type="email"
                  placeholder="Enter your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleNotify()}
                />
                <button className="onya-notify-submit" onClick={handleNotify}>Notify Me</button>
              </div>
              <p className="onya-notify-privacy">We respect your privacy. Unsubscribe at any time.</p>
            </>
          )}
          <div className="onya-notify-perks">
            <span className="onya-perk">Early Access to Launch</span>
            <span className="onya-perk">Exclusive Launch Offers</span>
            <span className="onya-perk">Skincare Tips &amp; Rituals</span>
          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="onya-footer">
        <div className="onya-footer-top">
          <div className="onya-f-brand">
            <span className="onya-f-logo">O N Y A</span>
            <p className="onya-f-tagline">Luxury skincare crafted for those who believe in the power of natural beauty and timeless self-care rituals.</p>
          </div>
          <div>
            <p className="onya-f-col-title">Quick Links</p>
            <div className="onya-f-links">
              <a href="#collection" onClick={(e) => { e.preventDefault(); scrollTo("collection"); }}>Products</a>
              <a href="#about" onClick={(e) => { e.preventDefault(); scrollTo("about"); }}>About Us</a>
              <a href="#notify" onClick={(e) => { e.preventDefault(); scrollTo("notify"); }}>Get Notified</a>
            </div>
          </div>
          <div>
            <p className="onya-f-col-title">Connect With Us</p>
            <div className="onya-f-socials">
              <a href="/" className="onya-f-social-btn" aria-label="Instagram">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5"/><circle cx="12" cy="12" r="4"/>
                  <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
                </svg>
              </a>
              <a href="/" className="onya-f-social-btn" aria-label="Facebook">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </a>
              <a href="/" className="onya-f-social-btn" aria-label="YouTube">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22.54 6.42a2.78 2.78 0 0 0-1.95-1.96C18.88 4 12 4 12 4s-6.88 0-8.59.46A2.78 2.78 0 0 0 1.46 6.42 29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58 2.78 2.78 0 0 0 1.95 1.96C5.12 20 12 20 12 20s6.88 0 8.59-.46a2.78 2.78 0 0 0 1.95-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/>
                  <polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02" fill="currentColor" stroke="none"/>
                </svg>
              </a>
            </div>
            <p className="onya-f-social-note">Follow us for skincare tips, exclusive previews, and launch updates.</p>
          </div>
        </div>
        <div className="onya-footer-bottom">
          <span className="onya-f-copy">© 2026 ONYA Skincare. All rights reserved.</span>
          <div className="onya-f-legal">
            <a href="/">Privacy Policy</a>
            <a href="/">Terms of Service</a>
          </div>
        </div>
      </footer>
    </>
  );
}